import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { PhotosImplementation } from '@commoncore/implementation/PhotosImplementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';

export class SharePhotosController{
  public photosImplementation:any;
  public fileOperationsImplementation:any;
  public universalService:any;
  public router:any;
  public http:any;
  public fetchFolderData:boolean=false;
  public static singleInstance:any = null;
  public listService:any;
  public sortOrder:any;
  loggerService: any
  shareAccessService: any;
  dcGroupCodePicker: any;
  sessionStorageService;any;
  constructor(private globalService: GlobalService) {
  this.photosImplementation= PhotosImplementation.getInstance(this.globalService);
  this.fileOperationsImplementation = FileOperationsImplementation.getInstance(this.globalService)
  this.setEnvObjects(globalService)
  }
  
  public static getInstance(globalService):SharePhotosController{
  if(this.singleInstance == null){
    this.singleInstance = new SharePhotosController(globalService);
    return this.singleInstance;
  }else{
    return this.singleInstance;
  }
}


public setEnvObjects(globalService) {
  this.universalService = globalService.getUniversalServiceRef();
  this.router = globalService.getRouterRef();
  this.http = globalService.getHttpClientRef();
  this.listService = globalService.getListServiceRef();
  this.loggerService = globalService.getLoggerServiceRef();
  this.shareAccessService = globalService.getShareAccessServiceRef();
  this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  this.sessionStorageService = globalService.getSessionStorageSvcRef();
}


 async getPhotos(){
    /*this.universalService.nameSort == null;
    this.universalService.showSortButtons = true;
    if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
      this.universalService.nameSort = false;
      this.sortOrder=this.listService.listViewSortOrder;
    } else {
      this.universalService.nameSort = true;
      this.sortOrder='&sort=%2BobjectName';
    }*/
    if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
      this.universalService.nameSort = false;
    } else {
      this.universalService.nameSort = true;
    }
    this.sortOrder = '&sort='+this.universalService.sharePublicSort;
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    //this.sortOrder = this.listService.listViewSortOrder;
    await this.dcGroupCodePicker.decideTypeOfShare(this.shareAccessService.univShareKey) 
    var photosUrl = SHARE_DC["DC_URLS"]["shareURL"] + ENV_CONFIG.commonUrls["enhancedSharePublicLink"] + '/' + this.shareAccessService.univShareKey + '?limit=' + limit +  '&filterCode=image' + this.sortOrder;
    this.photosImplementation.setHandler(this.globalService);
    try {
      let currentTime = new Date().getTime()
      await this.photosImplementation.decideSortOrder(photosUrl);
    } catch(exc){
      this.loggerService.log("exception handled for photos tab");
    }
  }


  async onScrollDown(docheignt,toppos){
      var url = "";
      await this.dcGroupCodePicker.decideTypeOfShare(this.shareAccessService.univShareKey) 
      url = SHARE_DC["DC_URLS"]["shareURL"] +  this.photosImplementation.photosnextLink;
      try{
      this.photosImplementation.createUrlForNextLink(docheignt,toppos,url);
      }
      catch(exc){
        this.loggerService.log("exception in scroll down")
      }
    }
    
    
    async updateUIAfterPerformingAction(list,executedTask){
      var array = [];
      if(!this.universalService.nameSort){
        array = this.photosImplementation.sortedPhotos;
      }else{
        array = this.universalService.sortByNameArray;
      }        

      if(executedTask == 'TRASH' || executedTask == "MOVE"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          if(executedTask == 'TRASH'
            || (!this.universalService.showPreview && executedTask == 'MOVE' && this.universalService.currentTab=='allfiles') ){
            var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
            array = result;
          }else{
            this.listService.deSelectAll(null);

          }

          if(executedTask == 'TRASH'){
            let arrayLength = -1
            if(this.universalService.nameSort){
              arrayLength=  this.universalService.sortByNameArray.length
            }else{
              arrayLength=  this.photosImplementation.sortedPhotos.length
            }
            if( arrayLength!=-1  && this.photosImplementation.photosnextLink.length>0){ //&& arrayLength<25
              this.photosImplementation.getNextPageData( SHARE_DC["DC_URLS"]["shareURL"] + this.photosImplementation.photosnextLink)
            }
          }
          
          
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
      }else{
          this.loggerService.log("task invalid",executedTask)
      }
    }

    openPublicSort(sortType,reverseOrder) {
      
      this.universalService.disableModalBackdrop();
      let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
      if(sortTypeName!=""){
          this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
      }
      //this.allFilesImplementation.allFilespreviousLink = "";
      this.getPhotos();
      this.universalService.isMobileTopMoreOptionMenu = false;
    }
  }